import React from "react";
import "../styles/ContactMe.css";

export default function ContactMe() {
        return (
                <div className="ContactMe">
                        <div>
                                <h1>Hi, I'm Nick, a web developer in Austin, TX.</h1>
                                <h2>Looking to get in touch? Send me an email at contact@iracingdata.com</h2>
                        </div>
                        <div>
                                <p>Questions or comments about the site? Email me at contact@iracingdata.com</p>
                        </div>
                </div>
        );
}
